<template xmlns="http://www.w3.org/1999/html">
    <tr>
        <td class="total-row-td"><span class="total-row-name">Total</span></td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.budget))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.baseline))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.profit))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.revenuePerPeriod))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.labour))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.material))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.profitPerPeriod))}}</td>
        <td class="percentage td-text total-row-td"></td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.etc2))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.estimatedCost))}}</td>
        <td class="currency td-text total-row-td">{{numberWithSpaces(Math.round(sumData.estimatedProfit))}}</td>
        <td class="percentage td-text total-row-td"></td>
    </tr>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'ProjectOverviewSumRow',
  props: { periodTo: '', categoryFilter: {}, selectedProjectLead: {} },
  components: {
  },
  watch: {
    overviewsDataLoaded: 'calculateRowsData',
    categoryFilter: {
      handler: function () {
        this.calculateRowsData(true);
      },
      deep: true
    },
    selectedProjectLead: {
      handler: function () {
        this.calculateRowsData(true);
      },
      deep: true
    }
  },
  data: function () {
    return {
      sumData: {
        budget: 0,
        baseline: 0,
        profit: 0,
        revenuePerPeriod: 0,
        labour: 0,
        material: 0,
        profitPerPeriod: 0,
        poc2: '',
        etc2: 0,
        estimatedCost: 0,
        estimatedProfit: 0,
        variance: ''
      }
    };
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('ProjectsOverview', [
      'overviewsDataLoaded',
      'actualsV1',
      'actualsV2',
      'materialsV1',
      'materialsV2',
      'etc',
    ]),
  },
  methods: {
    showProject(projectId) {
      const active = (this.projects[projectId].end_date >= this.periodTo);
      return (!this.categoryFilter['active'] || active) && this.categoryFilter[this.projects[projectId].category_id];
    },
    calculateRowsData(val) {
      if (val) {
        this.sumData = {
          budget: 0,
          baseline: 0,
          profit: 0,
          revenuePerPeriod: 0,
          labour: 0,
          material: 0,
          profitPerPeriod: 0,
          poc2: '',
          etc2: 0,
          estimatedCost: 0,
          estimatedProfit: 0,
          variance: ''
        };
        for (const i in this.projects) {
          if (this.selectedProjectLead.project_lead_id) {
            if (!this.categoryFilter['active']) {
              if (((this.projects[i].end_date && this.projects[i].end_date >= '2018-01-01' && this.projects[i].end_date < moment().format('YYYY-MM-DD'))
                              || (this.projects[i].change_requests_end_date && this.projects[i].change_requests_end_date >= '2018-01-01' && this.projects[i].change_requests_end_date < moment().format('YYYY-MM-DD')))
                              && this.categoryFilter[this.projects[i].category_id]
                              && this.projects[i].project_lead_id == this.selectedProjectLead.project_lead_id) {
                this.sumProject(this.projects[i].id);
              }
            } else if (((this.projects[i].end_date && this.projects[i].end_date >= moment(this.periodTo).format('YYYY-MM-DD'))
                              || (this.projects[i].change_requests_end_date && this.projects[i].change_requests_end_date >= moment(this.periodTo).format('YYYY-MM-DD')))
                              && this.categoryFilter[this.projects[i].category_id]
                              && this.projects[i].project_lead_id == this.selectedProjectLead.project_lead_id) {
              this.sumProject(this.projects[i].id);
            }
          } else if (!this.categoryFilter['active']) {
            if (((this.projects[i].end_date && this.projects[i].end_date >= '2018-01-01' && this.projects[i].end_date < moment().format('YYYY-MM-DD'))
                                || (this.projects[i].change_requests_end_date && this.projects[i].change_requests_end_date >= '2018-01-01' && this.projects[i].change_requests_end_date < moment().format('YYYY-MM-DD')))
                                && this.categoryFilter[this.projects[i].category_id]) {
              this.sumProject(this.projects[i].id);
            }
          } else if ((this.projects[i].end_date >= moment(this.periodTo).format('YYYY-MM-DD') || this.projects[i].change_requests_end_date >= moment(this.periodTo).format('YYYY-MM-DD')) && this.categoryFilter[this.projects[i].category_id]) {
            this.sumProject(this.projects[i].id);
          }
        }
      }
    },
    sumProject(projectId) {
      this.sumData.budget += this.contractBudget(projectId);
      this.sumData.baseline += this.contractBaselineCosts(projectId);
      this.sumData.profit += (this.contractBudget(projectId) - this.contractBaselineCosts(projectId));
      this.sumData.revenuePerPeriod += this.revenuePerPeriod(projectId);
      this.sumData.labour += (this.actualsV2[projectId] / 100) - (this.actualsV1[projectId] / 100);
      this.sumData.material += this.materialCosts(projectId).total / 100;
      this.sumData.profitPerPeriod += this.profitPerPeriod(projectId);
      this.sumData.etc2 += this.etc[projectId];
      this.sumData.estimatedCost += this.eac(projectId) / 100;
      this.sumData.estimatedProfit += this.expectedProfit(projectId);
    },
    profitPerPeriod(projectId) {
      const labourV1 = Math.round((this.actualsV1[projectId] / 100));
      const labourV2 = Math.round((this.actualsV2[projectId] / 100));
      let materialV1 = 0;
      let materialV2 = 0;
      for (var materialId in this.materialsV1) {
        var material = this.materialsV1[materialId];
        if (material.project_id == projectId) {
          materialV1 += parseInt(material.cost);
        }
      }
      for (var materialId in this.materialsV2) {
        var material = this.materialsV2[materialId];
        if (material.project_id == projectId) {
          materialV2 += parseInt(material.cost);
        }
      }
      const costs = (labourV2 + (materialV2 / 100)) - (labourV1 + (materialV1 / 100));
      return Math.round(this.revenuePerPeriod(projectId)) - costs;
    },
    materialCosts(projectId) {
      const materialCost = {
        materialV1: 0,
        materialV2: 0,
        total: 0
      };
      for (var materialId in this.materialsV2) {
        var material = this.materialsV2[materialId];
        if (material.project_id == projectId) {
          materialCost.total += parseInt(material.cost);
          materialCost.materialV2 = parseInt(material.cost);
        }
      }
      for (var materialId in this.materialsV1) {
        var material = this.materialsV1[materialId];
        if (material.project_id == projectId) {
          materialCost.total -= parseInt(material.cost);
          materialCost.materialV1 = parseInt(material.cost);
        }
      }
      return materialCost;
    },
    revenuePerPeriod(projectId) {
      let revenue = 0;
      const pocv1 = (this.actualsV1[projectId] + this.materialCosts(projectId).materialV1) / this.eac(projectId);
      const pocv2 = (this.actualsV2[projectId] + this.materialCosts(projectId).materialV2) / this.eac(projectId);
      revenue = (pocv2 - pocv1) * this.contractBudget(projectId);
      return revenue;
    },
    eac(projectId) {
      return (this.etc[projectId] * 100) + this.materialCosts(projectId).materialV2 + this.actualsV2[projectId];
    },
    expectedProfit(projectId) {
      return this.contractBudget(projectId) - (this.eac(projectId) / 100);
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    contractBudget(projectId) {
      let budget = this.projects[projectId].contract_budget;
      if (this.projects[projectId].change_requests.length) {
        const requests = this.projects[projectId].change_requests;
        for (const i in requests) {
          if (requests[i].start_date <= moment(this.periodTo).format('YYYY-MM-DD')) {
            budget += requests[i].contract_budget;
          }
        }
      }
      return budget;
    },
    contractBaselineCosts(projectId) {
      let baselineCosts = this.projects[projectId].baseline_costs;
      if (this.projects[projectId].change_requests.length) {
        const requests = this.projects[projectId].change_requests;
        for (const i in requests) {
          if (requests[i].start_date <= moment(this.periodTo).format('YYYY-MM-DD')) {
            baselineCosts += requests[i].baseline_costs;
          }
        }
      }
      return baselineCosts;
    },
  },
  mounted() {

  },
};
</script>
<style lang="scss" scoped>
    .total-row-td {
        border: 1px solid black;
        font-weight: bold;

    }
    .currency::before{
        content: "€";
    }
    .percentage::after{
        content: "%";
    }
    tr td:not(:first-child){
        text-align: right;
    }
    td {
        padding: 0;
    }
    .total-row-name {
        margin-left: 5px;
    }
    .td-text {
        vertical-align: middle;
        padding-right: 3px;
    }
</style>
